import { __assign } from 'tslib';
import SvgIcon from '@mui/material/SvgIcon';
import React from 'react';

function createSvgIcon(path, displayName) {
    var Component = React.memo(React.forwardRef(function (props, ref) { return (React.createElement(SvgIcon, __assign({}, props, { ref: ref }), path)); }));
    Component.displayName = displayName + 'Icon';
    return Component;
}

export { createSvgIcon as c };
